// Contenus des boutons de recommandation du parcours endométriose.
// Chaque entrée est affichée dans une modale (useAppModal) depuis le flow.
export const MODAL_CONTENT_ENDOMETRIOSIS = {
  PAIN_SCALE: {
    title: 'Dysménorrhée intense',
    content:
      'Si la douleur atteint une intensité de 8/10 ou plus, il s’agit d’une dysménorrhée intense, ' +
      'impactant fortement la qualité de vie de la patiente.',
  },

  MENSTRUAL_CYCLE: {
    title: 'Localisation de la douleur',
    content:
      'La localisation de la douleur peut aider le professionnel de santé à cibler un examen clinique ' +
      'et à déterminer le type d’endométriose dont la patiente est atteinte.',
  },

  PAIN_LOCATION: {
    title: 'Localisation de la douleur',
    content:
      'La localisation de la douleur peut aider le professionnel de santé à cibler un examen clinique ' +
      'et à déterminer le type d’endométriose dont la patiente est atteinte.',
  },

  DYSPAREUNIA: {
    title: 'Dyspareunie profonde',
    content:
      'On parle également de « dyspareunie profonde », ce symptôme témoigne d’une lésion près du vagin, ' +
      'au niveau de la cloison recto-vaginale, d’une inflammation qui accompagne une endométriose ' +
      'superficielle ou d’une adénomyose.',
  },

  INFERTILITY: {
    title: 'L’infertilité et l’endométriose',
    content:
      'Selon Endo France, 40% des femmes auraient du mal à concevoir. Il s’agit également du seul symptôme ' +
      'pour lequel la chirurgie peut être proposée comme traitement, afin d’améliorer les chances d’une ' +
      'grossesse naturelle.',
  },
} as const;
